import React, { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { useDispatch } from "react-redux";
import Firebase from "./firebasehelper";
import { saveSuperQuestions } from "./redux/actions";
import { setFaviconAndTitle } from "./Utils/utils";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import "./App.css";

import LogIn from "./screens/LogIn";
import SignUp from "./screens/SignUp";
// import Dashboard from "./screens/Dashboard";
import Retailers from "./screens/Retailers";
import SuperRetailers from "./screens/super_retailers";
import SuperRetailer from "./screens/super_retailer";
import Offers from "./screens/super_offers";
import Offer from "./screens/Offers";
import Portals from "./screens/Portals";
import PropertyPortals from "./screens/PropertyPortals";
import Brand from "./screens/Brand";
import Bespoke from "./screens/Bespoke";
import Programmes from "./screens/Programmes";
import ChatSuite from "./screens/ChatSuite";
import Chatbot from "./screens/Chatbot";
import Chatbots from "./screens/super_chatbots";
import Product from "./screens/Products";
import Polls from "./screens/Polls";
import SuperProducts from "./screens/super_products";
import Users from "./screens/Users";
import UserCategories from "./screens/UserCategories";
import BrandChannel from "./screens/BrandChannel";
import SuperTokenWallets from "./screens/SuperTokenWallets";
import Analytics from "./screens/Analytics";
import Team from "./screens/Team";
import Introducer from "./screens/Introducer";
import Contracts from "./screens/Contracts";
import SuperAnalytics from "./screens/SuperAnalytics";
import SuperContentPlanner from "./screens/SuperContentPlanner";
import UserPlatform from "./screens/UserPlatform";
import SuperChatSuite from "./screens/SuperChatSuite";
import Profile from "./screens/Profile";
import Feeds from "./screens/Feeds";
import Planner from "./screens/Planner";
import GamificationGoals from "./screens/GamificationGoals";
import AutoConcierge from "./screens/AutoConcierge";
import TokenEarning from "./screens/TokenEarning";
import BrandTokenEarning from "./screens/BrandTokenEarning";
import BrandAdmins from "./screens/BrandAdmins";
import Perks from "./screens/Perks";
import BrandDevelopers from "./screens/BrandDevelopers";
import BrandTaskers from "./screens/BrandTaskers";
import BrandCompletedDeal from "./screens/BrandCompletedDeal";
import CampaignDeal from "./screens/CampaignDeal";
import PlatformLinks from "./screens/PlatformLinks";
import UmbrellaAdmins from "./screens/UmbrellaAdmins";
import SuperAdmins from "./screens/SuperAdmins";
import Umbrella from "./screens/Umbrella";
import SuperInvestor from "./screens/SuperInvestor";
import UmbrellaChannel from "./screens/UmbrellaChannel";
import ChatbotMaker from "./screens/ChatbotMaker";
import SurveyMaker from "./screens/SurveyMaker";
import Competitions from "./screens/Competitions";
import BrandOffers from "./screens/BrandOffers";
import TodaySnapshot from "./screens/TodaySnapshot";
import AdventPlanner from "./screens/AdventPlanner";
import WelcomeMessage from "./screens/WelcomeMessage";
import LoginBot from "./screens/LoginBot";
import EcoToken from "./screens/EcoToken";
import Reviews from "./screens/Reviews";
import BespokeReviews from "./screens/BespokeReviews";
import Cause from "./screens/Cause";
import Event from "./screens/Event";
import TopRetailers from "./screens/TopRetailers";
import HotTopic from "./screens/HotTopic";
import EditHotTopic from "./screens/HotTopic/EditHotTopic";
import Api from "./screens/DeveloperIntegration/Api";
import iFrame from "./screens/DeveloperIntegration/Iframe";
import Guides from "./screens/DeveloperIntegration/Guides";
import Plugins from "./screens/DeveloperIntegration/Plugins";
import AdminSupport from "./screens/AdminSupport";
import SuperSupport from "./screens/SuperSupport";
import CalendarHub from "./screens/CalendarHub";
import BespokeBranding from "./screens/BespokeBranding";
import BespokeExplore from "./screens/BespokeExplore";
import BespokeIFrame from "./screens/BespokeIFrame";
import BespokeReferrals from "./screens/BespokeReferrals";
import Articles from "./screens/Articles";
import SuperArticles from "./screens/SuperArticles";
import ArticleView from "./screens/Articles/components/ArticleView";
import Categories from "./screens/Tasks/Categories";
import SubSite from "./screens/Tasks/SubSite";
import TicketTypes from "./screens/Tasks/TicketTypes";
import SuperTicketManagement from "./screens/SuperTicketManagement";
import TokensAndPots from "./screens/TokensAndPots";
import SuperDevs from "./screens/SuperDevs";
import SuperEcoEarnRetailers from "./screens/SuperEcoEarnRetailers";
import MemberReferrals from "./screens/MemberReferrals";
import TransactionalLedger from "./screens/TransactionalLedger";
import Checklist from "./screens/Checklist";
import ModerateContent from "./screens/ModerateContent";
import PendingCommunities from "./screens/PendingCommunities";
import FeaturedContent from "./screens/FeaturedContent";
import BespokeId from "./screens/BespokeId";
import CommunityRegistration from "./screens/CommunityRegistration";
import EmailNotification from "./screens/EmailNotification";
import BespokeCRMTabs from "./screens/BespokeCRMTabs";
import AdminRegistration from "./screens/AdminRegistration";
import ProductPortfolio from "./screens/ProductPortfolio";
import OnboardingSite from "./screens/OnboardingSite";
import MobileAccessDisclaimer from "./screens/LogIn/components/MobileAccessDisclaimer";

const App = () => {
  const dispatch = useDispatch();

  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    (async () => {
      // Get Super dbs
      const superQuestions = await Firebase.getSuperQuestions();
      dispatch(saveSuperQuestions(superQuestions));
    })();

    const checkDeviceStatus = () => setMobile(window.innerWidth < 1000);

    const isProduction = process.env.NODE_ENV === "production";
    const isLister = window.location.hostname.includes("list.");

    if (isProduction && !isLister) {
      checkDeviceStatus();
      window.addEventListener("resize", checkDeviceStatus);
    }

    setFaviconAndTitle();
  }, []);

  const shouldRouteExist = () => {
    const isAdmin = process.env.REACT_APP_USER === "admin";
    const { hostname } = window.location;
    const isGenericCRM = hostname.toLowerCase().includes("ecosystem");
    if (isAdmin || !isGenericCRM) return false;
    return true;
  };

  return isMobile ? (
    <MobileAccessDisclaimer />
  ) : (
    <Switch>
      <Route exact path="/" component={LogIn} />
      {/*--- public sign up pages  ---*/}
      {process.env.REACT_APP_USER === "brand" && (
        <Route path="/register" component={AdminRegistration} />
      )}
      {shouldRouteExist() && <Route exact path="/signup" component={SignUp} />}
      {/* <Route exact path="/dashboard" component={Dashboard} /> */}
      {/*--- Content Tab ---*/}
      <Route exact path="/planner" component={Planner} />
      <Route exact path="/hot-topic" component={HotTopic} />
      <Route exact path="/featured-content" component={FeaturedContent} />
      <Route exact path="/articles" component={Articles} />
      <Route exact path="/feeds" component={Feeds} />
      <Route exact path="/polls" component={Polls} />
      <Route exact path="/survey" component={SurveyMaker} />
      <Route exact path="/competitions" component={Competitions} />
      <Route exact path="/brand-offers" component={BrandOffers} />
      <Route exact path="/event" component={Event} />
      <Route exact path="/moderate-content" component={ModerateContent} />
      <Route exact path="/portfolio" component={ProductPortfolio} />
      {/*--- Content Super Tab ---*/}
      <Route exact path="/super-planner" component={Planner} />
      <Route exact path="/super-hot-topic" component={HotTopic} />
      <Route exact path="/super-articles" component={SuperArticles} />
      <Route exact path="/super-feeds" component={Feeds} />
      <Route exact path="/super-polls" component={Polls} />
      <Route exact path="/super-survey" component={SurveyMaker} />
      <Route exact path="/super-competitions" component={Competitions} />
      <Route exact path="/super-brand-offers" component={BrandOffers} />
      <Route exact path="/super-event" component={Event} />
      <Route
        exact
        path="/transactional-ledger"
        component={TransactionalLedger}
      />
      {/*--- Programme Tab ---*/}
      <Route exact path="/admin-support" component={AdminSupport} />
      <Route exact path="/user-platform" component={UserPlatform} />
      <Route exact path="/brand" component={Brand} />
      <Route exact path="/analytics" component={Analytics} />
      <Route exact path="/brand-admins" component={BrandAdmins} />
      <Route exact path="/brand-developers" component={BrandDevelopers} />
      {/*--- Deal Tab ---*/}
      <Route exact path="/channel" component={BrandChannel} />
      <Route exact path="/pending-communities" component={PendingCommunities} />
      <Route exact path="/completed-deals" component={BrandCompletedDeal} />
      <Route exact path="/campaign-deals" component={CampaignDeal} />
      <Route exact path="/platform-links" component={PlatformLinks} />
      {/*--- Super Community ---*/}
      <Route exact path="/umbrella-channel" component={UmbrellaChannel} />
      <Route exact path="/super-admins" component={SuperAdmins} />
      <Route exact path="/umbrella" component={Umbrella} />
      <Route exact path="/umbrella-admins" component={UmbrellaAdmins} />
      <Route exact path="/super-investors" component={SuperInvestor} />
      {/*--- Umbrella brand Community ---*/}
      <Route exact path="/team" component={Team} />
      <Route exact path="/introducer" component={Introducer} />
      <Route exact path="/contracts" component={Contracts} />
      {/*--- Sub brand Community ---*/}
      <Route exact path="/chatsuite" component={ChatSuite} />
      <Route exact path="/users" component={Users} />
      <Route exact path="/calendar-hub" component={CalendarHub} />
      <Route exact path="/viewreviews" component={Reviews} />
      {/*--- Connect Tab ---*/}
      <Route exact path="/chatbot-maker" component={ChatbotMaker} />
      <Route exact path="/auto-concierge" component={AutoConcierge} />
      <Route exact path="/chatbot" component={Chatbot} />
      <Route exact path="/welcome-message" component={WelcomeMessage} />
      <Route exact path="/login-bot" component={LoginBot} />
      {/*--- Bespoke Tab ---*/}
      <Route exact path="/bespoke-crm-tabs" component={BespokeCRMTabs} />
      <Route
        exact
        path="/admin-email-notifications"
        component={EmailNotification}
      />
      <Route exact path="/bespoke-live-tools" component={Bespoke} />
      <Route exact path="/bespoke-id" component={BespokeId} />
      <Route exact path="/bespoke-explore" component={BespokeExplore} />
      <Route exact path="/bespoke-iframe" component={BespokeIFrame} />
      <Route exact path="/bespoke-branding" component={BespokeBranding} />
      <Route exact path="/bespoke-referrals" component={BespokeReferrals} />
      <Route exact path="/user-categories" component={UserCategories} />
      <Route exact path="/bespokereviews" component={BespokeReviews} />
      {/*--- Referrals Tab ---*/}
      <Route exact path="/referrals" component={MemberReferrals} />
      <Route exact path="/registration" component={CommunityRegistration} />
      <Route exact path="/onboarding-site" component={OnboardingSite} />
      {/*--- Other ---*/}
      <Route exact path="/today-snapshot" component={TodaySnapshot} />
      <Route exact path="/programmes" component={Programmes} />
      <Route exact path="/portals" component={Portals} />
      <Route exact path="/propertyportals" component={PropertyPortals} />
      <Route exact path="/products" component={Product} />
      <Route exact path="/articles/:id" component={ArticleView} />
      <Route exact path="/chatbots" component={Chatbots} />
      <Route exact path="/wallets" component={SuperTokenWallets} />
      <Route exact path="/eco-tokens" component={EcoToken} />
      <Route exact path="/earn-tokens" component={SuperEcoEarnRetailers} />
      <Route exact path="/spend-tokens" component={Retailers} />
      <Route exact path="/perks" component={Perks} />
      <Route exact path="/super-products" component={SuperProducts} />
      <Route exact path="/offers" component={Offers} />
      <Route exact path="/offer" component={Offer} />
      <Route exact path="/retailer-details" component={SuperRetailer} />
      <Route exact path="/retailer" component={SuperRetailers} />
      <Route exact path="/eco-earn" component={SuperEcoEarnRetailers} />
      <Route exact path="/top-retailer" component={TopRetailers} />
      <Route exact path="/super-analytics" component={SuperAnalytics} />
      <Route exact path="/super-content" component={SuperContentPlanner} />
      <Route exact path="/super-chatsuite" component={SuperChatSuite} />
      <Route exact path="/advent-planner" component={AdventPlanner} />
      <Route exact path="/profile" component={Profile} />
      <Route exact path="/earn" component={TokenEarning} />
      <Route exact path="/tokens-and-pots" component={TokensAndPots} />
      <Route exact path="/token-earning" component={BrandTokenEarning} />
      <Route
        exact
        path="/incremental-tasks"
        render={(props) => (
          <BrandTokenEarning {...props} page="incremental-task" />
        )}
      />
      <Route
        exact
        path="/token-earning-all"
        render={(props) => <BrandTokenEarning {...props} page="all" />}
      />
      <Route
        exact
        path="/token-earning-hot"
        render={(props) => <BrandTokenEarning {...props} page="hot" />}
      />
      <Route exact path="/brand-taskers" component={BrandTaskers} />
      <Route exact path="/cause" component={Cause} />
      <Route exact path="/api" component={Api} />
      <Route exact path="/iFrame" component={iFrame} />
      <Route exact path="/guides" component={Guides} />
      <Route exact path="/plugins" component={Plugins} />
      <Route exact path="/super-support" component={SuperSupport} />
      <Route
        exact
        path="/super-ticket-types"
        component={SuperTicketManagement}
      />
      <Route exact path="/checklist" component={Checklist} />
      <Route exact path="/gamification-goals" component={GamificationGoals} />
      <Route exact path="/hot-topic/:id" component={EditHotTopic} />
      <Route exact path="/ticket-types" component={TicketTypes} />
      <Route exact path="/tasks-sub-site" component={SubSite} />
      <Route exact path="/ticket-categories" component={Categories} />
      <Route exact path="/superdevs" component={SuperDevs} />
      <Route path="*" render={() => <Redirect to="/" />} />
    </Switch>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js